export default __webpack_public_path__ + "static/media/montparnasse.7c05fcb3.png";